
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  useEffect(() => {
    // Scroll suave al cargar
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/af4df488990d06e39200aafc4099a5d2.jpg"
          alt="Europa iluminada desde el espacio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-8 py-40 flex flex-col items-center text-center">

        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-5 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-10">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block"></span>
          <span className="text-xs font-semibold tracking-[0.18em] text-white/90 uppercase">{t('hero_badge')}</span>
        </div>

        {/* Título principal */}
        <h1 className="text-4xl lg:text-5xl font-bold text-white leading-[1.2] tracking-tight mb-8 max-w-4xl">
          {t('hero_title_1')}
        </h1>

        {/* Subtítulo */}
        <p className="text-base lg:text-lg text-white/85 font-light tracking-wide mb-8 max-w-3xl leading-relaxed">
          {t('hero_subtitle')}
        </p>

        {/* Mercados prioritarios */}
        <div className="flex items-center gap-3 mb-14">
          <span className="w-8 h-px bg-white/40"></span>
          <p className="text-sm font-medium tracking-[0.12em] text-white/60 uppercase">
            {t('hero_markets')}
          </p>
          <span className="w-8 h-px bg-white/40"></span>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#contact"
            className="inline-flex items-center justify-center px-10 py-4 bg-[#1A2B4A] text-white text-sm font-semibold tracking-wide rounded-lg hover:bg-[#2A3B5A] transition-all cursor-pointer whitespace-nowrap group"
          >
            {t('hero_cta_talent')}
            <i className="ri-arrow-right-line ml-2 text-base group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="#contact"
            className="inline-flex items-center justify-center px-10 py-4 bg-transparent border border-white/50 text-white text-sm font-semibold tracking-wide rounded-lg hover:bg-white/10 hover:border-white transition-all cursor-pointer whitespace-nowrap"
          >
            {t('hero_cta_explore')}
          </a>
        </div>

      </div>
    </section>
  );
}
